import MemberPopup from './member-popup';

const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	$domUrl: $('body').data('url'),

	init: function() {
		if ($('#contactTabs').length < 1) return;

		// submit form
		$('.gform_button').on('click', ()=>{
			localStorage.setItem('submit', true);
		});
		// on load page
		$(document).ready(function() {
			let tab = MemberPopup.getUrlParameter('tab');

			if (localStorage.getItem('submit') === 'true') {
				tab = localStorage.getItem('tab');
			}
			if (!tab) return;

			// set url and push
			const url = Tabs.$domUrl + '?tab=' + tab;
			window.history.pushState('', '', url);

			$('.js-tab-manu li a').removeClass('active');
			if (!tab) return;
			$(`[data-rel="tab-${tab}"]`).addClass('active');
			$('#tab-'+tab).fadeIn('slow').siblings('.js-contact-tabs-content').hide();

			localStorage.setItem('submit', false);
		});

		$('.js-tab-manu li a').on('click', function() {
			const target = $(this).attr('data-rel');
			const tab = target.slice(4, 5);
			$('.js-tab-manu li a').removeClass('active');
			$(this).addClass('active');
			$('#'+target).fadeIn('slow').siblings('.js-contact-tabs-content').hide();

			localStorage.setItem('tab', tab);

			// push url address
			const url = Tabs.$domUrl + '?tab=' + tab;
			window.history.pushState('', '', url);
			return false;
		});

		$('.js-triger-tab-click').on('click', function() {
			event.preventDefault();
			setTimeout(function() {
				$('#newCertifications').click();
			}, 1050);
		});
	}
};

export default Tabs;
